var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 527,
    viewBox: "0 0 228 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180096_175517)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 254.714,
    cy: 253.714,
    r: 254.714,
    fill: "#2A3B6D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.362,
    cy: 268.988,
    r: 254.714,
    fill: "#FFDD89"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.011,
    cy: 284.262,
    r: 254.714,
    fill: "#EAA7B8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.663,
    cy: 299.535,
    r: 254.714,
    fill: "#445597"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.312,
    cy: 314.809,
    r: 254.714,
    fill: "#1D2A54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.655,
    cy: 328.286,
    r: 254.714,
    fill: "#FEE8B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180096_175517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 527,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circle-right.60e36473a3e73b3e536b063f37526400.svg";
export { ForwardRef as ReactComponent };